import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  makeStyles,
} from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";

const useStyles = makeStyles({
  listItem: {
    height: 40,
    marginTop: 7,
    "&:hover": {
      borderRadius: 20,
    },
    "& svg": {
      color: "#C9C8C8",
    },
    "& .MuiIconButton-root": {
      padding: 0,
    },
  },
  wrapperItem: {
    padding: 0,
  },
  activeListItem: {
    width: 255,
    borderRadius: 20,
    backgroundImage: "linear-gradient(278deg, #0F76AF, #004B81)",
    color: "white",
    "& svg": {
      color: "white",
    },
  },
  nestedListItem: {
    height: 40,
    width: 242,
    marginTop: 7,
    marginLeft: 10,
    paddingLeft: 75,
    color: "#000",
    "&:hover": {
      borderRadius: 20,
    },
    "& svg": {
      color: "#C9C8C8",
    },
  },
  activeNestedListItem: {
    borderRadius: 20,
    backgroundImage: "linear-gradient(278deg, #0F76AF, #004B81)",
    color: "white",
    "& svg": {
      color: "white",
    },
  },
});

interface OwnProps {
  handleDrawerToggle: () => void;
}
type Props = OwnProps;

const RepresentacionesItem: React.FC<Props> = (props) => {
  const { handleDrawerToggle } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (
      !pathname.startsWith("/representaciones") &&
      !pathname.startsWith("/representados")
    ) {
      setOpen(false);
    }
  }, [pathname]);

  const representacionesClicked = () => {
    setOpen((open) => !open);
  };

  return (
    <>
      <ListItem
        button
        className={classes.listItem}
        onClick={() => {
          representacionesClicked();
        }}
      >
        <ListItem className={classes.wrapperItem}>
          <ListItemIcon>
            <SupervisorAccountIcon />
          </ListItemIcon>
          <ListItemText primary="Representaciones" />
        </ListItem>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <NavLink
            to="/representaciones"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {({ isActive }) => (
              <ListItem
                button
                className={`${classes.nestedListItem} ${
                  isActive ? classes.activeNestedListItem : ""
                }`}
                onClick={handleDrawerToggle}
              >
                <ListItemText primary="Representaciones" />
              </ListItem>
            )}
          </NavLink>
          <NavLink
            to="/representados"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {({ isActive }) => (
              <ListItem
                button
                className={`${classes.nestedListItem} ${
                  isActive ? classes.activeNestedListItem : ""
                }`}
                onClick={handleDrawerToggle}
              >
                <ListItemText primary="Representados" />
              </ListItem>
            )}
          </NavLink>
        </List>
      </Collapse>
    </>
  );
};

export default RepresentacionesItem as React.ComponentType<Props>;
